import styled from 'styled-components';
import theme from '@theme';
import { FC, ReactNode } from 'react';

import { useTranslation } from 'react-i18next';
import InformationBlock from '@designSystem/InformationBlock';
import { ChatSquareFill } from 'react-bootstrap-icons';
import Badge from '@designSystem/Badges';
import { DateManager } from '../../utils/DateManager';

export const ReportCharacteristicsMAD: FC<{ characteristics: any }> = ({ characteristics }) => {
  const { t } = useTranslation();
  const { value, state } = characteristics;

  return (
    <CardReport>
      <ReportTitle>{t('features.order.orderInformations.commissioning')}</ReportTitle>
      <StyledCharacteristicDetails>
        {state && (
          <CharacteristicDetail
            title={`${t('features.order.orderInformations.state')} Mad`}
            subTitle={state}
          />
        )}

        {value.connectionDate && (
          <CharacteristicDetail
            title="Date"
            subTitle={new DateManager(value.connectionDate).format('DD/MM/YYYY : HH:mm')}
          />
        )}

        {value.failureReason && (
          <>
            <CharacteristicDetail
              title={`${t(
                'features.order.orderInformations.reasonForUnsuccessfulIntervention'
              )} CR MAD`}
              subTitle={<Badge variant="red">{value.failureLabel}</Badge>}
            />
            <CharacteristicDetail
              title={`${t('features.order.orderInformations.reasonCode')} CR MAD`}
              subTitle={value.failureReason}
            />
          </>
        )}
      </StyledCharacteristicDetails>

      {value.connectionComment && (
        <InformationBlock
          type="custom"
          customIcon={<ChatSquareFill fill={theme.palette.blue[500]} />}
          iconVariant="blue"
          title={`${t('features.order.orderInformations.comment')} CR MAD`}
          style={{ background: theme.palette.blue[100], color: theme.palette.blue[800] }}
        >
          {value.connectionComment}
        </InformationBlock>
      )}
    </CardReport>
  );
};
const CharacteristicDetail: FC<{ title: ReactNode; subTitle: ReactNode }> = ({
  title,
  subTitle
}) => {
  return (
    <StyledCharacteristicDetail>
      <Title>{title}</Title>
      <SubTitle>{subTitle}</SubTitle>
    </StyledCharacteristicDetail>
  );
};

const CardReport = styled.div`
  border-radius: 9px;
  border: 1px solid ${theme.palette.blue[200]};
  background: ${theme.palette.blue[50]};
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledCharacteristicDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: ${theme.fonts.size.sm};
`;

const StyledCharacteristicDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(182px, calc(100% / 3 - 20px)));
  gap: 20px;
`;

const Title = styled.div`
  color: ${theme.palette.grey[700]};
  font-weight: ${theme.fonts.weight.medium};
  line-height: 20px;
`;
const SubTitle = styled.div`
  color: ${theme.palette.grey[500]};
  font-weight: ${theme.fonts.weight.medium};
  line-height: 24px;
`;

const ReportTitle = styled.div`
  color: ${theme.palette.grey[500]};
  font-size: ${theme.fonts.size.sm};
  font-weight: ${theme.fonts.weight.medium};
  line-height: 24px;
`;
